import { render, staticRenderFns } from "./QuizResultView.vue?vue&type=template&id=546f2c2e&scoped=true"
import script from "./QuizResultView.vue?vue&type=script&lang=js"
export * from "./QuizResultView.vue?vue&type=script&lang=js"
import style0 from "./QuizResultView.vue?vue&type=style&index=0&id=546f2c2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546f2c2e",
  null
  
)

export default component.exports